<div class="host-search-date-and-house">
  <div class="flex flex-row">
    <div class="calendar">
      <host-one-month-calendar
        [defaultDate]="defaultDate"
        [dateType]="dateType"
        (dateChange)="dateChange($event)"
      ></host-one-month-calendar>
    </div>
    <div class="ml-6">
      <nz-tabset
        nzSize="large"
        [nzTabPosition]="'top'"
        [(nzSelectedIndex)]="activeIndex"
        (nzSelectedIndexChange)="statusChange()"
      >
        <!-- 空房可订 -->
        <nz-tab nzTitle="{{ 'word.available_houses' | translate }}"> </nz-tab>
        <nz-tab nzTitle="{{ 'component.search.all_empty_houses' | translate }}"> </nz-tab>
        <nz-tab nzTitle="{{ 'word.occupied' | translate }}"> </nz-tab>
      </nz-tabset>
      <div class="pt-[30px] max-h-[500px] overflow-y-auto">
        <host-search-houses-with-group-and-type
          [defaultHouses]="defaultHouses"
          [selectedHouses]="selectedHouses"
          [houseGroupList]="houseGroupList"
          [houseTypeList]="houseTypeList"
          [allHouseList]="allHouseList"
          [allowMultiSelect]="allowMultiSelect"
          (groupChange)="groupChange($event)"
          (typeChange)="typeChange($event)"
          (checkedHousesChange)="checkedHousesChange($event)"
        >
        </host-search-houses-with-group-and-type>
      </div>
    </div>
  </div>

  <div class="flex flex-row items-center justify-between">
    <!-- <p>
      <span>{{ dateInfo }}</span>
      <span style="padding-left: 5px;">{{ houseInfo }}</span>
    </p> -->
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="save()">
        {{ "word.confirm" | translate }}
      </button>
    </div>
  </div>
</div>
